<template>
    <Paper :header="$t('spotlight.workAuthorization.header')" tall>
        <EducationSkeleton v-if="isLoading" />
        <div v-else class="p-4 grid">
            <WorkAuthorizationItem
                v-for="(w, i) in workAuthorizations"
                :key="i"
                :code="w.code"
                :implicit="w.implicit"
                class="mb-3"
                :type="w.type"
                @onDelete="onItemDeleted"
            >
            </WorkAuthorizationItem>
            <BaseButton variant="outline-secondary" @click="openModal">
                {{ $t('spotlight.workAuthorization.addWorkAuthorization') }}
            </BaseButton>
        </div>
        <!-- <EducationModal
            :show="showModal"
            v-on:close="toggleModal"
            v-on:create="onCreate"
            v-on:save="onSave"
            v-on:delete="onDelete"
            :degree="selectedDegree"
        /> -->
    </Paper>
</template>

<script>
import DialogService from '~/services/DialogService';
import WorkAuthorizationItem from './WorkAuthorizationItem';
import EducationSkeleton from '../skeletons/EducationSkeleton';
export default {
    name: 'WorkAuthorization',
    components: {
        WorkAuthorizationItem,
        EducationSkeleton,
    },
    props: {
        value: {
            // WorkAuthorizations
            type: Array,
            default: () => [],
        },
        isLoading: {
            type: Boolean,
            default: () => true,
        },
    },
    data: () => ({
        workAuthorizations: [],
    }),
    watch: {
        value(data) {
            this.workAuthorizations = data;
        },
    },
    computed: {},
    methods: {
        listChanged() {
            this.$emit('change');
            this.$emit('input', this.workAuthorizations);
        },
        onAdd(data) {
            this.workAuthorizations.push(data);
            this.listChanged();
        },
        onClose() {},
        openModal() {
            DialogService.openWorkAuthorizationDialog(
                {
                    existing: this.workAuthorizations,
                },
                {
                    onAdd: this.onAdd,
                    close: this.onClose,
                }
            );
        },
        onItemDeleted(code) {
            this.workAuthorizations = this.workAuthorizations.filter(
                w => w.code !== code || w.implicit
            );
            this.listChanged();
        },
    },
};
</script>

<style scoped>
.grid {
    display: grid;
    grid-auto-rows: auto;
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
}
</style>
